import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../hooks/hooks';
import { selecttenantDomainFunctionsListItems, selecttenantDomainFunctionsQueryItems } from '../../../../../redux/TenantDomainFunctions/selector';
import { tenantDomainFunctions } from '../../../../../redux/TenantDomainFunctions/action';
import TenantDomainFunctionComponent from '../components/tenant-domain-function.component';
import PageLoader from '../../../../../components/PageLoader';
import { selectFeaturesListItems } from '../../../../../redux/features/selector';
import { features } from '../../../../../redux/features/action';
import { selectDomainsListItems } from '../../../../../redux/domains/selector';
import { domains } from '../../../../../redux/domains/action';


const TenantDomainFunctions= () => {  
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const queryItems = useSelector(selecttenantDomainFunctionsQueryItems)
 const DomainItems = useSelector(selecttenantDomainFunctionsListItems)
 const routeQuery = useSelector(selectFeaturesListItems)
 const [isLoading, setIsLoading] = useState<boolean>(true)
 const domainItems = useSelector(selectDomainsListItems)
  
const [isQuery, setIsQuery] = useState<boolean>(false)
  const [
    selectedDomain,
    setSelectedDomain
  ] = useState<any>( {
    FeatureId: 0,
    DomainId: 0,
    FunctionName: '',
    CustomFunctionName: '',
    FunctionTypeId: 0,
    ParentFunctionId: null,
    FunctionLevelId: 0,
    IsActive: false,
    IsTagAllowed: false,
    IsTenantEntityAttributeAllowed: false,
    HasFolder: false,
    DisplayOrder: 0,
    Icon: '',
    Route: '',
    Description: '',
    Color: '',
    Code: '',
    IsTemplateMappingEnabled: false
  })
  const [
    parentDomain,
    setParentDomain
  ] = useState<any>([])

  const fetchTenatDomainFunctionById= ()=>{
    dispatch(tenantDomainFunctions.query({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/functions/query`,entity:'tenantDomainFunctions',jsonData:{
          
    Records: [
      {
        
          
              "Id": parmas?.id
          
      
       
      }
    ]
  
}})).then(()=>{
  setIsQuery(true)
})




  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedDomain({ ...selectedDomain, [field]: event });
  }

  useEffect(
    () => {
     
        dispatch(features.list({
            url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/features/list`,
            entity: 'features',
            jsonData: {}
        })).then(()=>{
          dispatch(tenantDomainFunctions.list({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/functions/list`,entity:'tenantDomainFunctions',jsonData:{
          }})).then(()=>{
            dispatch(domains.list({
              url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/domains/list`,
              entity: 'domains',
              jsonData: {}
          }))}).then(()=>{
      if (parmas?.id > 0) {
        fetchTenatDomainFunctionById()
        setIsLoading(false)
      }
      else{
        setIsLoading(false)
      }
    })
  })
    },
    []
  )
  useEffect(
    () => {
        
      if (isQuery) {
        setSelectedDomain(queryItems?.result?.items)
        setParentDomain(DomainItems?.result?.items)
      }
    },
    [isQuery]
  )
 
const handleFormSubmit  = async (event: any) => {
    event.preventDefault();
    if (parmas?.id > 0) {
      await dispatch(tenantDomainFunctions.resetAction({ actionType: 'update' }))
      await dispatch(tenantDomainFunctions.update({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/functions`,entity:'tenantDomainFunctions',jsonData:{
          
    Records: [
         selectedDomain
    ]
 
}})).then(()=>{
  back()
})

    }else{
      await dispatch(tenantDomainFunctions.resetAction({ actionType: 'create' }))
      await dispatch(tenantDomainFunctions.create({url:`https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/functions`,entity:'tenantDomainFunctions',jsonData:{
          
      Records: [
          selectedDomain
      ]
    
  }})).then(()=>{
    back()
  })
    }

  }

const back=()=>{
  navigate('/management/platform-management/functions')
} 
    return (
    <>
      {isLoading ? <PageLoader /> : 
          <TenantDomainFunctionComponent 
           handleInnerFormChange={handleInnerFormChange}
           selectedDomain={selectedDomain}
           back={back}
           handleFormSubmit={handleFormSubmit}
           domain={routeQuery?.result?.items}
           parentDomain={parentDomain}
           domainDetails={domainItems?.result?.items}
          />  }
          </>
    )
    
    }
   
    export default TenantDomainFunctions;